import React from "react";
import LandingPage from "./LandingPage";

export default function Aprovacao() {
  return <LandingPage slug="geral" />;
}
